<kendo-scheduler
    *ngIf="schedulerReady"
    class="tt-scheduler"
    kendoSchedulerSlotSelectable
    [events]="events"
    [resources]="resources"
    [group]="group"
    [editable]="editableSettings"
    [selectable]="ttSlotSelection"
    [selectedDate]="selectedDate"
    [selectedViewIndex]="selectedViewIndex"
    [eventHeight]="eventHeight"
    [columnWidth]="columnWidth"
    [showWorkHours]="showWorkHours"
    [allDaySlot]="allDaySlot"
    [weekStart]="weekStart"
    [startTime]="startTime"
    [endTime]="endTime"
    [workDayStart]="workDayStart"
    [workDayEnd]="workDayEnd"
    [slotDuration]="slotDuration"
    [slotDivisions]="slotDivisions"
    [scrollTime]="scrollTime"
    [eventStyles]="eventStyles"
    [slotSelection]="$any(slotSelection)"
    (selectedViewIndexChange)="onSelectedViewIndexChange($event)"
    (dateChange)="onDateChange($event)"
    (eventClick)="onEventClick($event)"
    (slotClick)="onSlotClick($event)"
    (slotSelectionChange)="onSlotSelectionChange($event)"
    (dragEnd)="onDragEnd($event)"
    (resizeEnd)="onResizeEnd($event)"
    (save)="onSave($event)"
    (remove)="onRemove($event)"
    (click)="onSchedulerClick($event)"
    style="height: 100%"
>
    <kendo-scheduler-messages
        [allEvents]="schedulerMessages.allEvents"
        [allDay]="schedulerMessages.allDay"
        [dateHeader]="schedulerMessages.dateHeader"
        [timeHeader]="schedulerMessages.timeHeader"
        [eventHeader]="schedulerMessages.eventHeader"
        [deleteTitle]="schedulerMessages.deleteTitle"
        [nextTitle]="schedulerMessages.nextTitle"
        [previousTitle]="schedulerMessages.previousTitle"
        [today]="schedulerMessages.today"
        [calendarToday]="schedulerMessages.calendarToday"
        [showFullDay]="schedulerMessages.showFullDay"
        [showWorkDay]="schedulerMessages.showWorkDay"
        [dayViewTitle]="schedulerMessages.dayViewTitle"
        [weekViewTitle]="schedulerMessages.weekViewTitle"
        [workWeekViewTitle]="schedulerMessages.workWeekViewTitle"
        [monthViewTitle]="schedulerMessages.monthViewTitle"
        [timelineViewTitle]="schedulerMessages.timelineViewTitle"
        [timelineWeekViewTitle]="schedulerMessages.timelineWeekViewTitle"
        [timelineMonthViewTitle]="schedulerMessages.timelineMonthViewTitle"
        [agendaViewTitle]="schedulerMessages.agendaViewTitle"
        [cancel]="schedulerMessages.cancel"
        [save]="schedulerMessages.save"
        [destroy]="schedulerMessages.destroy"
        [deleteConfirmation]="schedulerMessages.deleteConfirmation"
        [deleteDialogTitle]="schedulerMessages.deleteDialogTitle"
        [selectView]="schedulerMessages.selectView"
    ></kendo-scheduler-messages>

    <ng-template kendoSchedulerEventTemplate let-event="event">
        <div class="tt-scheduler__event">
            <span class="tt-scheduler__event-title">{{ event.title }}</span>
            <span class="tt-scheduler__event-time" *ngIf="!event.isAllDay">{{ formatSchedulerTimeRange(event.start, event.end) }}</span>
            <div class="tt-scheduler__event-description" *ngIf="getEventDescriptionHtml(event) as descriptionHtml" [innerHTML]="descriptionHtml"></div>
            <span class="tt-scheduler__event-description" *ngFor="let text of getEventSubText(event)">{{ text }}</span>
        </div>
    </ng-template>

    <ng-template kendoSchedulerDateHeaderTemplate let-date="date">
        <span class="tt-scheduler__date-header" [title]="formatSchedulerHeaderDate(date)">{{ formatSchedulerHeaderDate(date) }}</span>
    </ng-template>

    <ng-template kendoSchedulerMajorTimeHeaderTemplate let-date="date">
        <span class="tt-scheduler__time-header">{{ formatSchedulerTime(date) }}</span>
    </ng-template>

    <ng-template kendoSchedulerMinorTimeHeaderTemplate let-date="date">
        <span class="tt-scheduler__time-header">{{ formatSchedulerTime(date) }}</span>
    </ng-template>

    <ng-template kendoSchedulerAgendaDateTemplate let-date="date">
        <span class="tt-scheduler__agenda-date" [title]="formatSchedulerHeaderDate(date)">{{ formatSchedulerHeaderDate(date) }}</span>
    </ng-template>

    <ng-template kendoSchedulerAgendaTimeTemplate let-start="start" let-end="end" let-isAllDay="isAllDay">
        <span class="tt-scheduler__agenda-time">{{ formatSchedulerAgendaTime(start, end, isAllDay) }}</span>
    </ng-template>

    <kendo-scheduler-timeline-view *ngIf="hasView('timeline')" [selectedDateFormat]="schedulerSingleDateFormat" [selectedShortDateFormat]="schedulerSingleDateFormat"></kendo-scheduler-timeline-view>
    <kendo-scheduler-timeline-week-view
        *ngIf="hasView('timelineWeek')"
        [selectedDateFormat]="schedulerRangeDateFormat"
        [selectedShortDateFormat]="schedulerRangeDateFormat"
    ></kendo-scheduler-timeline-week-view>
    <kendo-scheduler-timeline-month-view
        *ngIf="hasView('timelineMonth')"
        [selectedDateFormat]="schedulerSingleDateFormat"
        [selectedShortDateFormat]="schedulerSingleDateFormat"
    ></kendo-scheduler-timeline-month-view>

    <kendo-scheduler-day-view *ngIf="hasView('day')" [selectedDateFormat]="schedulerSingleDateFormat" [selectedShortDateFormat]="schedulerSingleDateFormat"></kendo-scheduler-day-view>
    <kendo-scheduler-work-week-view *ngIf="hasView('workWeek')" [selectedDateFormat]="schedulerRangeDateFormat" [selectedShortDateFormat]="schedulerRangeDateFormat"></kendo-scheduler-work-week-view>
    <kendo-scheduler-week-view *ngIf="hasView('week')" [selectedDateFormat]="schedulerRangeDateFormat" [selectedShortDateFormat]="schedulerRangeDateFormat"></kendo-scheduler-week-view>
    <kendo-scheduler-month-view
        *ngIf="hasView('month')"
        [eventHeight]="eventHeight"
        [selectedDateFormat]="schedulerSingleDateFormat"
        [selectedShortDateFormat]="schedulerSingleDateFormat"
    ></kendo-scheduler-month-view>
    <kendo-scheduler-agenda-view *ngIf="hasView('agenda')" [selectedDateFormat]="schedulerRangeDateFormat" [selectedShortDateFormat]="schedulerRangeDateFormat"></kendo-scheduler-agenda-view>
</kendo-scheduler>
